import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getTranslate } from '../../localization'
import useStyles from './styles/PaymentTermFooter.styles'

interface PaymentTermFooterProps {
  isSubmitting: boolean
  loadingForPaymentTerm: boolean
}

export const PaymentTermFooter: React.FC<PaymentTermFooterProps> = ({
  isSubmitting,
  loadingForPaymentTerm
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting}
        data-cy="SavePaymentTermButton"
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
        fullWidth={matches}>
        {getTranslate('Save PaymentTerm')}
        {loadingForPaymentTerm && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
